import React from 'react';
import { CollectionCard } from '../../ui/users/CollectionCard';
import { CollectionsGrid } from '../../ui/users/CollectionsGrid';
import { useCollectionsController } from './useCollectionsController';
import { withCollectionCallbacks } from './withCollectionCallbacks';

const EnhancedCollectionCard = withCollectionCallbacks(CollectionCard);

export function UserCollections() {
    const collectionsController = useCollectionsController();

    return (
        <CollectionsGrid
            collections={collectionsController.collections}
            isLoading={collectionsController.isLoading}
            renderItem={(index) => (
                <EnhancedCollectionCard
                    key={collectionsController.collections[index].id}
                    collection={collectionsController.collections[index]}
                />
            )}
        />
    );
}
